module.exports = __webpack_public_path__ + "img/AGR-i-1-I.6688619d.png";